import React from 'react';

const Overview = () => (
    <div style={cardStyle}>
        <h2 style={{color: '#1a2234'}}> United Motors Overview</h2>
        <hr />
        <div style={{display: 'flex', gap: '20px', marginTop: '20px'}}>
            <div style={statBox}><h3>0</h3><p>Total Bikes</p></div>
            <div style={statBox}><h3>0</h3><p>Sales Today</p></div>
            <div style={statBox}><h3>0</h3><p>Active Staff</p></div>
        </div>
        <p style={{marginTop: '20px', color: '#64748b'}}>Welcome back, Masood. System is stable.</p>
    </div>
);

const cardStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' };
const statBox = { flex: 1, padding: '20px', backgroundColor: '#f8fafc', borderRadius: '8px', textAlign: 'center', border: '1px solid #e2e8f0' };

export default Overview;